(() => {
  angular.module('app').component('heatmapGrid', {
    template: `<div class="heatmap-grid">
        <canvas id="grid"></canvas>
        <!--<div class="grid-controls">
          <input type="range" ng-if="!ctrl.disableSlider"
               min="4" max="50" ng-model="ctrl.currentGridSize"
               ng-change="ctrl.handleGridSizeChange()" />
        </div> -->
        <div id="tooltip" class="tooltip fade in"
       style="position: absolute; display: none; pointer-events: none;">
          <div class="tooltip-arrow"></div>
          <div class="tooltip-inner"></div>
       </div>
      </div>`,
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      dimensions: '<',
      gridSize: '<',
      weights: '<',
      disableSlider: '<',
      onChange: '&',
      palette: '<?',
    },
  });

  Controller.$inject = ['$element', '$timeout', '$scope'];

  function generateGradientColors(startColor, endColor, steps) {
    const start = {
      r: parseInt(startColor.slice(1, 3), 16),
      g: parseInt(startColor.slice(3, 5), 16),
      b: parseInt(startColor.slice(5, 7), 16),
    };
    const end = {
      r: parseInt(endColor.slice(1, 3), 16),
      g: parseInt(endColor.slice(3, 5), 16),
      b: parseInt(endColor.slice(5, 7), 16),
    };

    const colors = [];
    for (let i = 0; i < steps; i++) {
      const t = i / (steps - 1);
      const r = Math.round(start.r + (end.r - start.r) * t);
      const g = Math.round(start.g + (end.g - start.g) * t);
      const b = Math.round(start.b + (end.b - start.b) * t);
      colors.push(`rgba(${r}, ${g}, ${b}, 1)`);
    }
    return colors;
  }

  const defaultPalette = generateGradientColors('#fff3d1', '#992304', 10);

  function Controller($element, $timeout, $scope) {
    const vm = this;
    vm.currentGridSize = 10;
    let firstRun = true;

    vm.$onInit = function () {
      $timeout(() => {
        vm.container = $element.find('div');
        vm.gridCanvas = $element.find('#grid')[0];
        vm.tooltip = $element.find('#tooltip')[0];

        vm.gridCanvas.addEventListener('mousemove', function (evt) {
          const rect = vm.gridCanvas.getBoundingClientRect();
          const mouseX = evt.clientX - rect.left;
          const mouseY = evt.clientY - rect.top;

          const width = vm.dimensions.originalSize.width;
          const height = vm.dimensions.originalSize.height;
          const gridPx = getGridSizeInPx(width, height, vm.currentGridSize);
          const gridPxRatio = gridPx * vm.dimensions.ratio;

          const col = Math.floor(mouseX / gridPxRatio) * gridPx;
          const row = Math.floor(mouseY / gridPxRatio) * gridPx;

          const weight = getWeightForCell(col, row, vm.weights);

          if (!weight) {
            vm.tooltip.style.display = 'none';
            return;
          }

          tooltip.style.display = 'block';

          const tooltipRect = tooltip.getBoundingClientRect();
          const canvasRect = vm.gridCanvas.getBoundingClientRect();

          let left = mouseX + 15;
          let top = mouseY + 15;

          const tooltipWidth = tooltipRect.width;
          const tooltipHeight = tooltipRect.height;

          const maxLeft = canvasRect.width - tooltipWidth - 5; // margen de seguridad
          const maxTop = canvasRect.height - tooltipHeight - 5;

          if (left > maxLeft) {
            left = mouseX - tooltipWidth - 15;
          }
          if (top > maxTop) {
            top = mouseY - tooltipHeight - 15;
          }

          tooltip.style.left = left + 'px';
          tooltip.style.top = top + 'px';

          tooltip.querySelector('.tooltip-inner').innerText = weight.toFixed(2);
        });

        vm.gridCanvas.addEventListener('mouseleave', function () {
          tooltip.style.display = 'none';
        });

        vm.disableSlider = typeof vm.disableSlider === 'boolean' ? vm.disableSlider : !!vm.weights;

        $scope.$watch('ctrl.dimensions.width', (newValue, oldValue) => {
          reset();
        });

        reset();
      }, 20);
    };

    vm.$onChanges = function (changes) {
      if (firstRun) {
        firstRun = false;
        return;
      }

      reset();
    };

    vm.handleGridSizeChange = function () {
      if (!vm.container) {
        return;
      }
      vm.gridSize = vm.currentGridSize;
      reset();
      $timeout(() => {
        vm.onChange({ gridSize: vm.gridSize });
      });
    };

    function reset() {
      // Ajusta el container
      const container = vm.container[0];
      container.style.height = vm.dimensions.height + 'px';
      container.style.top = vm.dimensions.offset.top + 'px';

      // Configura canvas
      vm.gridCanvas.width = vm.dimensions.width;
      vm.gridCanvas.height = vm.dimensions.height;
      vm.gridCanvas.style.width = vm.dimensions.width + 'px';
      vm.gridCanvas.style.height = vm.dimensions.height + 'px';
      vm.gridCanvas.style.opacity = 0.6;

      const ctx = vm.gridCanvas.getContext('2d');
      ctx.clearRect(0, 0, vm.dimensions.width, vm.dimensions.height);

      if (!vm.gridSize || typeof vm.gridSize !== 'number') {
        return;
      }

      vm.normalizedWeights = normalizeWeights(vm.weights);
      vm.currentGridSize = vm.gridSize;

      drawGrid(ctx, vm.dimensions, vm.gridSize, vm.weights);
    }

    function drawGrid(ctx, dimensions, gridSize, weights) {
      const width = dimensions.originalSize.width;
      const height = dimensions.originalSize.height;

      const gridPx = getGridSizeInPx(width, height, gridSize);
      const gridPxRatio = gridPx * dimensions.ratio;

      const normalizedWeights = vm.normalizedWeights;

      for (let x = 0; x < width; x += gridPx) {
        const x2 = x * vm.dimensions.ratio;
        for (let y = 0; y < height; y += gridPx) {
          if (weights) {
            const weight = getWeightForCell(x, y, normalizedWeights);
            ctx.fillStyle = getHeatmapColor(weight);

            ctx.fillRect(x2, y * vm.dimensions.ratio, gridPxRatio, gridPxRatio);
          }
          ctx.strokeStyle = '#ffffff';
          ctx.lineWidth = 0.5;

          const y2 = y * vm.dimensions.ratio;

          ctx.strokeRect(x2, y2, gridPxRatio, gridPxRatio);
        }
      }
    }

    function normalizeWeights(weights) {
      if (!weights || typeof weights !== 'object') {
        return {};
      }

      const normalized = {};
      let maxWeight = 0;

      for (const row in weights) {
        for (const col in weights[row]) {
          const weight = weights[row][col];
          if (weight > maxWeight) {
            maxWeight = weight;
          }
        }
      }

      for (const row in weights) {
        normalized[row] = {};
        for (const col in weights[row]) {
          const weight = weights[row][col];
          normalized[row][col] = maxWeight > 0 ? weight / maxWeight : 0;
        }
      }

      return normalized;
    }

    function getGridSizeInPx(width, height, gridSizePercent) {
      const minSide = Math.min(width, height);
      return Math.floor((minSide * gridSizePercent) / 100);
    }

    function getWeightForCell(x, y, weights) {
      return weights?.[x]?.[y] || 0;
    }

    function getHeatmapColor(weight) {
      if (weight === 0) {
        return 'rgba(255, 255, 255, 0)';
      }
      if (weight < 0 || weight > 1) {
        return 'rgba(255, 255, 255, 0)';
      }

      const index = Math.min(Math.floor(weight * defaultPalette.length), defaultPalette.length - 1);
      return defaultPalette[index] || '#ffffff';
    }
  }
})();
